// (ملف جديد: src/WebhookSetupPage.js)
import React, { useState } from 'react';
import { db } from './firebase';
import { doc, updateDoc } from 'firebase/firestore';

// ده كومبوننت جديد بيستقبل 3 حاجات: اليوزر، وبيانات العميل، والدالة اللي بتحدث البيانات
function WebhookSetupPage({ user, clientData, setClientData }) {
  const [secret, setSecret] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // 1. بنبني الرابط الكامل أوتوماتيك من البيانات
  const fullWebhookURL = `https://n8n2.dafaiagency.shop/webhook/147faf8a-13b0-4c4c-9722-5dd24579d459/shopify-hook-alsayes2/${clientData.webhook_path_id}`;

  const handleSaveSecret = async (e) => {
    e.preventDefault();
    if (!secret) {
      setError('لا يمكن ترك الحقل فارغاً');
      return;
    }
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // 2. بنحدد مكان الدوكيومنت بتاع العميل (اللي هو اسم البراند)
      const clientDocRef = doc(db, 'clients_v2', clientData.brand_name);
      
      // 3. بنحدث الحقل بتاع السيكرت بس
      await updateDoc(clientDocRef, {
        shopify_shared_secret: secret
      });

      // 4. (مهم) بنحدث الـ state في الداش بورد عشان الصفحة تتغير
      setClientData(prevData => ({
        ...prevData,
        shopify_shared_secret: secret
      }));

      setSuccess('تم الحفظ بنجاح! سيتم تحديث الصفحة.');
      // الصفحة هتتغير لوحدها لأن الـ state اتغيرت

    } catch (err) {
      console.error(err);
      setError('حدث خطأ أثناء الحفظ. حاول مرة أخرى.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={setupStyles.container}>
      <div style={setupStyles.card}>
        <h2 style={{color: '#667eea', marginBottom: '10px'}}>🎉 خطوة واحدة أخيرة يا {clientData.brand_name}!</h2>
        <p style={{color: '#333', fontSize: '16px', marginBottom: '20px'}}>تم إنشاء حسابك بنجاح. لتفعيل الخدمة، يرجى إتباع الآتي:</p>
        
        <ol style={setupStyles.list}>
          <li>اذهب إلى لوحة تحكم شوبيفاي (Shopify Admin).</li>
          <li>اذهب إلى <span style={setupStyles.code}>Settings &gt; Notifications</span>.</li>
          <li>انزل لآخر الصفحة حتى تجد قسم "Webhooks".</li>
          <li>اضغط "Create webhook".</li>
          <li>في خانة "Event"، اختر **"Order creation"**.</li>
          <li>في خانة "Format"، اختر **"JSON"**.</li>
          <li>في خانة "URL"، انسخ الرابط التالي:</li>
        </ol>

        <input 
          type="text" 
          readOnly 
          value={fullWebhookURL} 
          style={setupStyles.input} 
        />
        <button onClick={() => navigator.clipboard.writeText(fullWebhookURL)} style={setupStyles.copyButton}>
          نسخ الرابط
        </button>

        <div style={setupStyles.secretSection}>
          <p style={setupStyles.secretTitle}>📋 الخطوة الأخيرة:</p>
          <p style={setupStyles.secretInstructions}>
            بعد الضغط على <strong>"Save"</strong> في شوبيفاي، هيظهرلك <strong>"Signing secret"</strong>.<br/>
            انسخه والصقه في الخانة اللي تحت، واضغط "حفظ وتفعيل".
          </p>
        </div>

        <form onSubmit={handleSaveSecret}>
          <input 
            type="text" 
            placeholder="Shopify Shared Secret"
            value={secret}
            onChange={(e) => setSecret(e.target.value)}
            style={setupStyles.input}
          />
          <button type="submit" disabled={loading} style={setupStyles.saveButton}>
            {loading ? 'جاري الحفظ...' : 'حفظ وتفعيل'}
          </button>
        </form>
        {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        {success && <p style={{ color: 'green', marginTop: '10px' }}>{success}</p>}
      </div>
    </div>
  );
}

// ستايلات لصفحة الإعداد
const setupStyles = {
  container: {
    padding: '20px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
    padding: '35px',
    maxWidth: '750px',
    width: '100%',
    textAlign: 'right',
  },
  list: {
    textAlign: 'right', // 🔥 عشان الخطوات
    paddingRight: '20px', // 🔥 عشان الخطوات
    lineHeight: '1.8',
    color: '#333',
    fontSize: '15px',
  },
  code: {
    backgroundColor: '#eee',
    padding: '2px 6px',
    borderRadius: '4px',
    fontFamily: 'monospace',
  },
  input: {
    width: '100%',
    padding: '12px',
    margin: '10px 0',
    boxSizing: 'border-box',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    textAlign: 'left', // 🔥 عشان الرابط والسيكرت
  },
  copyButton: {
    width: '100%',
    padding: '10px',
    backgroundColor: '#f0f0f0',
    color: '#333',
    border: '1px solid #ccc',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: 'bold',
  },
  saveButton: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  secretSection: {
    marginTop: '30px',
    marginBottom: '20px',
    padding: '20px',
    backgroundColor: '#f0f8ff',
    borderLeft: '4px solid #667eea',
    borderRadius: '6px',
  },
  secretTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#667eea',
    marginBottom: '10px',
  },
  secretInstructions: {
    fontSize: '15px',
    lineHeight: '1.8',
    color: '#333',
    margin: 0,
  }
};

export default WebhookSetupPage;